import React from 'react'
import PropTypes from 'prop-types'

import { Cancel, RefreshSharp } from '@mui/icons-material'
import Colors from 'utils/Colors'
import { Button } from '@mui/material'
import styles from './styles'

function ErrorMessage(props) {
  const {
    message,
    buttonText,
    actionCallback,
    iconSize = '10rem',
    color = Colors.red,
    IconComponent = Cancel,
    fontSize = 'inherit',
    buttonVariant = 'contained',
  } = props

  const classes = styles()

  return (
    <div className={classes.root}>
      <div style={{ fontSize: iconSize }}>
        <IconComponent fontSize='inherit' style={{ color }} />
      </div>

      <p style={{ fontSize }}>{message}</p>

      {buttonText && actionCallback && (
        <Button
          onClick={actionCallback}
          startIcon={<RefreshSharp fontSize='small' />}
          variant={buttonVariant}
          color='primary'
          style={{
            marginTop: '20px',
            textTransform: 'none',
          }}
        >
          {buttonText}
        </Button>
      )}
    </div>
  )
}

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  actionCallback: PropTypes.func,
  iconSize: PropTypes.string,
  color: PropTypes.string,
  IconComponent: PropTypes.elementType,
  fontSize: PropTypes.string,
  buttonVariant: PropTypes.oneOf(['contained', 'text', 'outlined']),
}

ErrorMessage.defaultProps = {
  buttonText: null,
  actionCallback: null,
  iconSize: '10rem',
  color: Colors.red,
  IconComponent: Cancel,
  fontSize: 'inherit',
  buttonVariant: 'contained',
}

export default ErrorMessage
